let topic = [
    {
        path: '/topic/content',
        name: 'list',
        component: () => import('@/views/topic/content/list.vue'),
        meta: {keepAlive: true, parentPath: 'topic'},
    },
    {
        path: '/topic/content/edit',
        name: 'edit',
        component: () => import('@/views/topic/content/edit.vue'),
        meta: {keepAlive: true, parentPath: 'topic'},
    },
    {
        path: '/topic/category',
        name: 'category',
        component: () => import('@/views/topic/category.vue'),
        meta: {keepAlive: true, parentPath: 'topic'},
    }
 

    
    
]
export default topic


// WEBPACK FOOTER //
// ./src/router/topic.js